import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './TableCell.module.scss';

function TableCell({ children, className, ...remainingProps }) {
  return (
    <td
      className={classNames(styles.root, className)}
      {...remainingProps}
    >
      {children}
    </td>
  );
}

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TableCell;
